import { render, staticRenderFns } from "./BtnZzimWithApi.vue?vue&type=template&id=55766194"
import script from "./BtnZzimWithApi.vue?vue&type=script&lang=js"
export * from "./BtnZzimWithApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports